import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ProductRelatedAccessoriesCard from 'Component/ProductRelatedAccessoriesCard';

import { MAX_VISIBLE_ITEMS } from './ProductRelatedAccessories.config';

import './ProductRelatedAccessories.style';

/** @namespace Pwa/Component/ProductRelatedAccessories/Component */
export class ProductRelatedAccessories extends PureComponent {
    static propTypes = {
        productsRelated: PropTypes.array,
    };

    static defaultProps = {
        productsRelated: [],
    };

    renderContent() {
        const { productsRelated } = this.props;
        if (!productsRelated || productsRelated.length === 0) return null;
        let productsRelatedArr = productsRelated;

        if (productsRelated.length > MAX_VISIBLE_ITEMS) {
            productsRelatedArr = productsRelated.slice(0, MAX_VISIBLE_ITEMS);
        }

        return (
            <div block="ProductRelatedAccessories">
                <p block="ProductRelatedAccessories" elem="OfferTitle">
                    {__('Complete your purchase')}
                </p>
                <div block="ProductRelatedAccessories" elem="Container">
                    {productsRelatedArr.map((product) => (
                        <ProductRelatedAccessoriesCard key={product.id} product={product} />
                    ))}
                </div>
            </div>
        );
    }

    render() {
        return this.renderContent();
    }
}

export default ProductRelatedAccessories;
